var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            "custom-class": "",
            "close-on-click-modal": false,
            visible: _vm.innerVisible,
            title: _vm.$t("SeaExport.checkGoods")
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            },
            close: function($event) {
              _vm.innerVisible = false
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "app-main-inner-row row-grid" },
            [
              _c("cargo-ag-grid", {
                style: { width: "100%", height: "450px" },
                attrs: {
                  "config-module": "130133",
                  "show-side-bar": false,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }